import React, { useMemo } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Home } from "./pages";
import { FullHeightLoading } from "./App.style";

export const MemorizedHome: React.FC = () => {
  const HomeComponent = useMemo(() =>
    React.createElement(
        withAuthenticationRequired(() => <Home />, {
            onRedirecting: () => <FullHeightLoading />,
        })
    ), []);

    return HomeComponent;
};
